// extracted by mini-css-extract-plugin
module.exports = {"Anchor":"UserAuthButton_Anchor__1aGYy","ListWrapper":"UserAuthButton_ListWrapper__2IanN","ListItem":"UserAuthButton_ListItem__3WzMZ","User":"UserAuthButton_User__3qP75"};